import {Component, OnInit} from '@angular/core';
import {ToolsService} from '../../../../services/tools.service';

@Component({
  selector: 'app-booking-faq',
  templateUrl: './booking-faq.component.html',
  styleUrls: ['./booking-faq.component.scss'],
})
export class BookingFaqComponent implements OnInit {
  public collapsed: boolean = true;

  constructor(private tools: ToolsService) {}

  public ngOnInit(): void {}

  public togglePanel(): void {
    this.collapsed = !this.collapsed;
  }
}
